import moment from 'moment'

export const searchItems = [
  {
    label: '人员姓名',
    type: 'input',
    decorator: ['name'],
    placeholder: '请输入人员姓名'
  },
  {
    label: '证件号码',
    type: 'input',
    decorator: ['certNo'],
    placeholder: '请输入证件号码'
  },
  {
    label: '设备SN',
    type: 'input',
    decorator: ['deviceSn'],
    placeholder: '请输入设备SN'
  },
  {
    label: '支付宝酒店名称',
    type: 'input',
    decorator: ['zfbHotelProjectName'],
    placeholder: '请输入支付宝酒店名称'
  },
  // 查询时间
  {
    label: '采集时间',
    type: 'timeRange',
    decorator: [
      'dateTimeRange',
      {
        initialValue: [moment().startOf('day'), moment().endOf('day')]
      }
    ],
    placeholder: ['查询时间 (起始)', '查询时间 (终止)'],
    disabledDate: c => c && c > moment().endOf('day'),
    ranges: {
      今日: [moment().startOf('day'), moment().endOf('day')],
      近一周: [moment().subtract(7, 'days').startOf('day'), moment().endOf('day')],
      近两周: [moment().subtract(15, 'days').startOf('day'), moment().endOf('day')],
      近一月: [moment().subtract(30, 'days').startOf('day'), moment().endOf('day')]
    }
  }
]
